/* eslint-disable jsx-a11y/alt-text */
import Icon from "@common/Icon";
import Drawer from "@components/shared/Drawer";
import { PRODUCT_WARRANTY } from "@constants/product";
import AppContext from "@helpers/context";
import { IProduct } from "@interfaces/product";
import { editProduct } from "@network/api/product";
import {
  IRowsKey,
  Notifications,
  Progress,
  ViewRowInterchange,
} from "d-react-components";
import { useFormik } from "formik";
import { useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import ProductInputWarranty from "../input/ProductInputWarranty";

interface IProductDetailWarranty {
  open: boolean;
  defaultValue?: any;
  onUpdated: any;
  onClose: () => void;
}

const ProductDetailWarrantyDrawer = ({
  open,
  defaultValue,
  onUpdated,
  onClose,
}: IProductDetailWarranty) => {
  const { t } = useTranslation();
  const { productId } = useParams();

  const productForm = useFormik<any>({
    initialValues: defaultValue as any,
    validateOnChange: false,
    validateOnBlur: false,
    // validationSchema: schema,
    onSubmit: (values: any) => {
      onUpdateProduct(values);
    },
  });
  const formValues = productForm?.values;
  const formErrors = productForm?.errors;

  const onUpdateProduct = (values: any) => {
    const { warrantyPeriod, warranty } = values;

    const body = {
      productid: productId,
      has_warranty_period: warranty === PRODUCT_WARRANTY.AVAILABLE,
      warranty_period: warrantyPeriod,
    };

    Progress.show(
      {
        method: editProduct,
        params: [body],
      },
      (res: any) => {
        Notifications.showSuccess(t("updateSuccess"));
        onUpdated();
        onClose();
      }
    );
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={t("warranty")}
      size="auto"
      width="80vw"
      onSave={() => {
        productForm.handleSubmit();
      }}
    >
      <div>
        <ProductInputWarranty productForm={productForm} />
      </div>
    </Drawer>
  );
};

const ProductDetailWarranty = () => {
  const { productDetail, loadProductDetail } = useContext(AppContext);
  const [openEdit, setOpenEdit] = useState(false);
  const { t } = useTranslation();

  const DETAILS_KEY = useMemo<IRowsKey<IProduct>[]>(
    () => [
      {
        id: "warranty",
        label: t("warranty"),
      },
      {
        id: "warrantyPeriod",
        label: t("warrantyPeriod"),
        renderContent: ({ data, item }) => data + "months",
      },
    ],
    [t]
  );

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mt-3">
        <h5>{t("warranty")}</h5>
        <span onClick={() => setOpenEdit(true)}>
          <Icon
            className="w-[15px] cursor-pointer"
            src="/images/icons/edit.svg"
          />
        </span>
      </div>
      <div className="mt-3 border p-4 ">
        <ViewRowInterchange
          dataSource={productDetail}
          keyList={DETAILS_KEY as any}
          variant="border"
          classNameLabel="text-hint "
          classNameContent="text-end "
        />
        {openEdit && (
          <ProductDetailWarrantyDrawer
            open={openEdit}
            onClose={() => setOpenEdit(false)}
            defaultValue={productDetail}
            onUpdated={loadProductDetail}
          />
        )}
      </div>
    </div>
  );
};

export default ProductDetailWarranty;
